"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorBoldIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h4.832C13.908 6 16 6.5 16 9q0 2-1 2.5 2 .5 2 3c0 .5 0 3.5-4 3.5H8a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1m1 10h3.5c1 0 2-.25 2-1.5s-1.104-1.5-2-1.5H9zm0-4.975h3c.504 0 2 0 2-1.525S12 8 12 8H9z"/></svg>`
}, props));
EditorBoldIcon.displayName = 'EditorBoldIcon';
var _default = exports.default = EditorBoldIcon;